module.exports = __webpack_public_path__ + "img/Taavon_Eslami.ac15b6e0.svg";